import { translateDomain } from '../../../utils/labels_utils';

export const tableControls = (t) => [
  { id: "scfControl", type: "text", label: t('company:complianceProgram.dashboard.table.control'), sortable: true },
  {
    id: "scfDomain",
    type: "dropdown",
    label: t('company:complianceProgram.dashboard.table.domain'),
    sortable: true,
    format: (v) => (v ? translateDomain(t, v) : ''),
  },
  { id: "controlWeighting", type: "number", label: t('company:complianceProgram.dashboard.table.weight'), sortable: true },
  { id: "status", label: t('company:complianceProgram.dashboard.table.status'), type: "status"},
  { id: "maturity_level", label: t('company:complianceProgram.dashboard.table.maturity'), type: "maturity-level" },
  { id: "actions-view", type: "actions-view", label: "" },
];
